import { FLEX_MONTHLY, MONTHLY } from "constants/financialProducts";
import { FinancialProduct } from "providers/pricing/PricePoints";

const formatNumber = (num: number, decimals = 0): string => {
  const decimalValue = Number(num).toFixed(decimals).valueOf();
  return new Intl.NumberFormat("en-US").format(parseFloat(decimalValue));
};

const formatToOneDecimal = (num: number): string => {
  const oneDecimalNumber = Math.round(Number(num) * 10) / 10;
  return new Intl.NumberFormat("en-US").format(oneDecimalNumber);
};

const formatPercent = (number: number, maxDecimal: number = 2): string => {
  return `${(number * 100).toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: maxDecimal,
  })}%`;
};

const formatCurrency = (value?: number | null, decimals = 0) => {
  if (value === null || value === undefined) {
    return "N/A";
  }
  const currencyValue = Number(value).toFixed(decimals);
  const negative = currencyValue.startsWith("-") ? "-" : "";
  return `${negative}$${currencyValue
    .replace(/^(?:-)/, "")
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`;
};

const formatProductCost = (
  value: number | string,
  paymentType: FinancialProduct
) => {
  let productCost = "";
  if (Number(value) > 0) {
    productCost = formatCurrency(Number(value));
    if (paymentType === MONTHLY || paymentType === FLEX_MONTHLY) {
      productCost += "/mo";
    }
  }
  return productCost;
};

const formatProductMinMaxCost = (
  minValue: number | string | undefined,
  maxValue: number | string,
  paymentType: FinancialProduct
) => {
  if (!minValue || minValue === maxValue) {
    return formatProductCost(maxValue, paymentType);
  }
  let productCost = `${formatCurrency(Number(minValue)) || "N/A"} - ${
    formatCurrency(Number(maxValue)) || "N/A"
  }`;
  if (paymentType === MONTHLY || paymentType === FLEX_MONTHLY) {
    productCost += "/mo";
  }
  return productCost;
};

export {
  formatCurrency,
  formatNumber,
  formatToOneDecimal,
  formatPercent,
  formatProductCost,
  formatProductMinMaxCost,
};
